import LoadableDeviationDuperbrowseContext from '@wix/da-shared-react/pkg/Duperbrowse/LoadableDeviationDuperbrowseContext';
import LoadableDuperbrowseContextContainer from './LoadableDuperbrowseContext.container';

export default LoadableDuperbrowseContextContainer(
  LoadableDeviationDuperbrowseContext
);
